import React from 'react';
import { useField } from 'formik';
import { Q1Value } from 'models/documents';
import { DataGridRow } from 'components/DataGrid';
import Checkbox from 'components/Buttons/CheckboxButton';

export interface Props {
  name: string;
  row: DataGridRow;
  focus: boolean;
  code: number;
  disabled?: boolean;
}

const CellBooleanInput = ({ name, row, code, disabled }: Props) => {
  const [field, , helpers] = useField<Q1Value>(name);

  // Formatting and updating the rows state on inputs change
  const onFieldChange = (value: boolean) => {
    const body: DataGridRow[] | undefined = field.value.body?.map((elem: DataGridRow) => {
      if (elem.id === row.id) {
        return {
          ...elem,
          [code]: {
            content: value ? 'true' : 'false',
            pageNumber: -1,
            boundingBox: {
              x1: -1,
              y1: -1,
              x2: -1,
              y2: -1,
            },
          },
        };
      }
      return elem;
    });
    if (body) helpers.setValue({ ...field.value, body });
  };

  let value = false;
  const fieldValue = field.value.body?.find(({ id }) => id === row.id);
  if (fieldValue) {
    value = (fieldValue[code]?.content as 'true' | 'false') === 'true';
  }

  return <Checkbox isActive={value} name={name} isEditable={!disabled} action={onFieldChange} />;
};

export default CellBooleanInput;
